import { NewNames as NewNamesForm } from '@bgea-js/form-templates';
import donationHeaderSignsOfChristmas from "../../../../src/content/signs-of-christmas/donationHeader";
import "../../../../src/content/signs-of-christmas/signs-of-christmas.scss";
import * as React from 'react';
export default {
  NewNamesForm,
  donationHeaderSignsOfChristmas,
  React
};